/*
 * Copyright 2019 LABOR.digital
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2019.12.30 at 21:08
 */
import clone from 'clone';
/**
 * A typescript wrapper for the clone package
 * @param list The list to be cloned
 * @param options Additional options for the internal clone package
 * @see https://github.com/pvorb/clone
 */
export function cloneList(list, options) {
    return clone(list, options !== null && options !== void 0 ? options : {});
}
//# sourceMappingURL=cloneList.js.map